import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { Table, TableContainer, ThTable, ThTableItem } from './SmrtSearchTableNew'
import { useLexicon } from '../../hooks/useLexicon'
import { useParameterLexicon } from '../../hooks/useParameterLexicon'
import { useTranslation } from 'react-i18next';
import { extractFirstCharacters } from '../../helpers';
import { getMatchScoreParts } from '../../helpers/matchScore';

import { ReactComponent as SortAscIcon } from "../../images/icons/sortasc_icon.svg";
import { ReactComponent as SortDescIcon } from "../../images/icons/sort_desc.svg";
import { ReactComponent as SortDefaultIcon } from "../../images/icons/sort_default.svg";
import logo from "../../images/contactLogo.svg";
import more from "../../images/ic_more.svg";
import play from "../../images/ic_play.svg";
import playMatchBlue from "../../images/play_match_blue.svg";
import playMatchDarkActive from "../../images/ic_play_active.svg";
import playMatchBlueActive from "../../images/ic_play_active_blue.svg";
import emptySearch from "../../images/ic_empty.svg";
import playInBall from "../../images/ic_playinball.svg";
import playInBallBlue from "../../images/playInBall_blue.svg";
import statistics from "../../images/ic_statistics.svg";
import statisticsBlue from "../../images/statistics_blue.svg";
import formation from "../../images/ic_formation.svg";
import formationBlue from "../../images/formation_blue.svg";

import { Action, MatchContent, MatchInfo, Score, TeamMatches, TeamName, TeamScore } from '../../style/MatchTable';
import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';
import { Formation } from '../Formation';
import useOutsideClick from '../../hooks/useOutsideClick';
import { createPortal } from 'react-dom';
import { EmptyState } from '../../style/Tournaments';
import { Oval } from 'react-loader-spinner';
import { openVideoList } from '../../helpers/service';
import styled from "styled-components";

const TopHorizontalScroll = styled.div`
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    margin-bottom: 8px;
    height: 14px;
`;

const TopHorizontalScrollInner = styled.div`
    height: 1px;
`;

const TopOnlyTableContainer = styled(TableContainer)`
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: auto;

    &::-webkit-scrollbar:horizontal {
        display: none;
        height: 0;
    }
`;

const CompetitionMatchItemMenu = ({ item, currentTeam, tableRef, seasonId }) => {
    const l = useLexicon();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [openRow, setOpenRow] = useState(false);
    const [openFormation, setOpenFormation] = useState(false);
    const [selectedFormationMatch, setSelectedFormationMatch] = useState(null)
    const [position, setPosition] = useState("bottom");

    const [menuCoords, setMenuCoords] = useState(null);

    useEffect(() => {
        if (openRow && menuDropdownRef.current && tableRef.current) {
            const menuRect = menuDropdownRef.current.getBoundingClientRect();
            const scrollableParent = tableRef.current || document.documentElement;
            const parentRect = scrollableParent.getBoundingClientRect();

            const newPosition = menuRect.bottom + 250 > parentRect.bottom ? "top" : "bottom";
            setPosition(newPosition);
            setMenuCoords({ top: menuRect.top, left: menuRect.left });
        }
    }, [openRow]);

    useEffect(() => {
        if (openRow && menuDropdownRef.current && tableRef.current) {
            const menuRect = menuDropdownRef.current.getBoundingClientRect();
            const tableRect = tableRef.current.getBoundingClientRect();

            if (menuRect.bottom + 250 > tableRect.bottom) {
                setPosition("top");
            } else {
                setPosition("bottom");
            }
        }
    }, [openRow]);

    const menuDropdownRef = useOutsideClick(() => {
        if (openRow) {
            setOpenRow(false);
        }
    });

    const handleOpenFormation = (match) => {
        setSelectedFormationMatch(match);
        setOpenFormation(true);
    };

    const handleCloseFormation = () => {
        setOpenFormation(false);
        setSelectedFormationMatch(null);
    };

    const getWinner = (score, isHome) => {
        let scoreColor;
        if (isHome) {
            if (+score[0] > +score[2]) {
                scoreColor = "#36e82d";
            } else if (+score[0] === +score[2]) {
                scoreColor = "#E8D02D";
            } else {
                scoreColor = "#f20a46";
            }
        } else if (+score[2] > +score[0]) {
            scoreColor = "#36e82d";
        } else if (+score[0] === +score[2]) {
            scoreColor = "#E8D02D";
        } else {
            scoreColor = "#f20a46";
        }
        return scoreColor;
    };

    const onBallEventsClick = (match, new_tab) => {
        const obeHome = match?.home_team?.stats?.find(
            (item) =>
                item.parameter_name === "On-Ball Events" || item.parameter_id === 13
        )?.markers || [];
        const obeAway = match?.away_team?.stats?.find(
            (item) =>
                item.parameter_name === "On-Ball Events" || item.parameter_id === 13
        )?.markers || [];
        const markers = [...obeHome, ...obeAway]
        if (markers?.length > 0 && new_tab) {   
           openVideoList(markers?.join(","), "On-Ball Events", true);
        } else {
           openVideoList(markers?.join(","), "On-Ball Events");

        }
    };

    return (
        <>
            <TeamScore style={{ position: "relative" }} ref={menuDropdownRef}>
                <span
                    style={{
                        color: getWinner(item.score, true),
                    }}
                >
                    {getMatchScoreParts(item)[0]}
                </span>
                <span
                    style={{
                        color: getWinner(item.score, false),
                    }}
                >
                    {getMatchScoreParts(item)[1]}
                </span>
                <img
                    style={{ right: 'auto' }}
                    className="more"
                    src={more}
                    alt={more}
                    onClick={() => setOpenRow(prev => !prev)}

                />
                {openRow && menuCoords && createPortal(
                    <MatchInfo
                        style={{
                            // top: position === "top" ? "auto" : "100%", 
                            // bottom: position === "top" ? "100%" : "auto",
                            top: position === "top" ? `${menuCoords?.top - 210}px` : `${menuCoords?.top + 30}px`,
                            left: `${menuCoords?.left}px`,
                            zIndex: 9999
                        }}
                    >
                        <MatchContent>
                            <Action
                                style={{
                                    cursor: item?.video ? 'pointer' : 'not-allowed',
                                    opacity: item?.video ? '1' : '0.5',
                                }}
                                onClick={() => {
                                    if (item?.video) {
                                       window.open(`/tournaments/match/video/${item.id}`, "_blank");
                                    }
                                }}
                            // onContextMenu={() =>
                            //   window.open(
                            //     `/tournaments/match/video/${item.id}`,
                            //     "_blank"
                            //   )
                            // }
                            >
                                <img
                                    src={
                                        localStorage.getItem("theme") === "light"
                                            ? item?.video
                                                ? playMatchBlueActive
                                                : playMatchBlue
                                            : item?.video
                                                ? playMatchDarkActive
                                                : play
                                    }
                                    alt={play}
                                />
                                <h4
                                    className={
                                        item?.video ? "haveMatch" : ""
                                    }
                                >
                                    {item?.video ? l(1019) : t("matchActions.notAvailable")}
                                </h4>
                            </Action>
                            <Action
                                onClick={() => onBallEventsClick(item)}
                                onContextMenu={() =>
                                    onBallEventsClick(item, true)
                                }
                            >
                                <img
                                    src={
                                        localStorage.getItem("theme") === "light"
                                            ? playInBallBlue
                                            : playInBall
                                    }
                                    alt={playInBall}
                                />
                                <h4>{l(334)}</h4>
                            </Action>
                            <Action
                                onClick={() =>
                                    navigate(`/tournaments/statistics/${item.id}`)
                                }
                                onContextMenu={() =>
                                    window.open(
                                        `/tournaments/statistics/${item.id}`,
                                        "_blank"
                                    )
                                }
                            >
                                <img
                                    src={
                                        localStorage.getItem("theme") === "light"
                                            ? statisticsBlue
                                            : statistics
                                    }
                                    alt={statistics}
                                />
                                <h4>{l(1020)}</h4>
                            </Action>
                            <Action
                                onClick={() => handleOpenFormation(item)}
                                onContextMenu={() => handleOpenFormation(item)}
                            >
                                <img
                                    src={
                                        localStorage.getItem("theme") === "light"
                                            ? formationBlue
                                            : formation
                                    }
                                    alt={formation}
                                />
                                <h4>{l(1021)}</h4>
                            </Action>
                        </MatchContent>
                    </MatchInfo>,
                    document.body
                )}
            </TeamScore>
            {/* display formation */}
            <Formation
                open={openFormation}
                handleClose={(handleCloseFormation)}
                match={selectedFormationMatch}
            />
        </>
    )
}

export const CompetitionMatchesTable = ({ data, tempSelectedFilters, loading, handleSortTable, tableTypeSorting }) => {
    const l = useLexicon();
    const { getTeamParameterLexiconId } = useParameterLexicon();
    const tableRef = useRef(null);
    const topScrollRef = useRef(null);
    const syncScrollLockRef = useRef(false);
    const [topScrollWidth, setTopScrollWidth] = useState(0);
    const [isTopScrollVisible, setIsTopScrollVisible] = useState(false);

    const getParameterDisplayName = (parameterName) => {
        if (!parameterName) return '';
        const lexiconId = getTeamParameterLexiconId(parameterName);
        if (lexiconId) return l(lexiconId) || parameterName;
        return parameterName;
    };

    const tableHeadNames = useMemo(() => {
        if (data?.length > 0) {
            const dataWithParams = data.find(item => item?.home_team?.stats?.length > 0);
            if (dataWithParams) {
                return dataWithParams.home_team.stats.filter(item => tempSelectedFilters?.checkedIds?.includes(item.parameter_id));
            }
            return tempSelectedFilters.params || []
        }
        return tempSelectedFilters.params || [];
    }, [data, tempSelectedFilters]);

    const isCanClickStat = (parameter) => {
        return (
            parameter?.value === 0 ||
            parameter?.markers?.length === 0 ||
            parameter?.parameter_name.includes("%") ||
            parameter?.parameter_name.includes("Mins Played")
        );
    };

    const getRoundName = (row) => {
        const val = row?.round_name ?? row?.round ?? row?.matchday ?? row?.match_round ?? null;
        return val != null && typeof val === 'object' ? val?.name ?? val?.title ?? null : val;
    };

    const colSpanCount = 2 + (tableHeadNames?.length || 0);

    const updateTopScrollbarState = useCallback(() => {
        const tableNode = tableRef.current;
        const topNode = topScrollRef.current;

        if (!tableNode) return;

        const hasHorizontalOverflow = tableNode.scrollWidth > tableNode.clientWidth + 1;
        setIsTopScrollVisible(hasHorizontalOverflow);
        setTopScrollWidth(tableNode.scrollWidth);

        if (topNode) {
            topNode.scrollLeft = tableNode.scrollLeft;
        }
    }, []);

    useEffect(() => {
        updateTopScrollbarState();
        const rafId = window.requestAnimationFrame(updateTopScrollbarState);
        window.addEventListener('resize', updateTopScrollbarState);
        window.addEventListener('navigationOpenChange', updateTopScrollbarState);

        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined' && tableRef.current) {
            resizeObserver = new ResizeObserver(() => {
                updateTopScrollbarState();
            });
            resizeObserver.observe(tableRef.current);
        }

        return () => {
            window.cancelAnimationFrame(rafId);
            window.removeEventListener('resize', updateTopScrollbarState);
            window.removeEventListener('navigationOpenChange', updateTopScrollbarState);
            resizeObserver?.disconnect();
        };
    }, [updateTopScrollbarState, data, loading, tableHeadNames?.length]);

    useEffect(() => {
        const tableNode = tableRef.current;
        const topNode = topScrollRef.current;

        if (!tableNode || !topNode) return;

        const syncFromTop = () => {
            if (syncScrollLockRef.current) return;
            syncScrollLockRef.current = true;
            tableNode.scrollLeft = topNode.scrollLeft;
            window.requestAnimationFrame(() => {
                syncScrollLockRef.current = false;
            });
        };

        const syncFromBottom = () => {
            if (syncScrollLockRef.current) return;
            syncScrollLockRef.current = true;
            topNode.scrollLeft = tableNode.scrollLeft;
            window.requestAnimationFrame(() => {
                syncScrollLockRef.current = false;
            });
        };

        topNode.addEventListener('scroll', syncFromTop, { passive: true });
        tableNode.addEventListener('scroll', syncFromBottom, { passive: true });

        return () => {
            topNode.removeEventListener('scroll', syncFromTop);
            tableNode.removeEventListener('scroll', syncFromBottom);
        };
    }, [isTopScrollVisible, topScrollWidth]);

    return (
        <>
            {isTopScrollVisible && (
                <TopHorizontalScroll ref={topScrollRef}>
                    <TopHorizontalScrollInner style={{ width: `${topScrollWidth}px` }} />
                </TopHorizontalScroll>
            )}
            <TopOnlyTableContainer ref={tableRef}>
                <Table>
                    <ThTable>
                        <tr>
                            <th className='sticky name' style={{ textAlign: 'left', paddingLeft: 20 }}>{l(991)}</th>
                            <th className='sticky season'>{l(123)}</th>
                            {tableHeadNames?.map(item => {
                                const paramName = typeof item === 'string' ? item : (item?.parameter_name || item?.name);
                                const displayName = getParameterDisplayName(paramName);
                                return (
                                <ThTableItem
                                    title={displayName}
                                    key={item.parameter_id || item.id}
                                    onClick={() => handleSortTable(item)}
                                >
                                    {extractFirstCharacters(displayName)}
                                    {
                                        tableTypeSorting.type === 'asc' && tableTypeSorting.param === (item.parameter_id || item.id) ? (
                                            <SortAscIcon />
                                        ) : tableTypeSorting.type === 'desc' && tableTypeSorting.param === (item.parameter_id || item.id) ? (
                                            <SortDescIcon />
                                        ) : (
                                            <SortDefaultIcon />
                                        )
                                    }
                                </ThTableItem>
                            );
                            })}
                        </tr>
                    </ThTable>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={tableHeadNames?.length < 10 ? tableHeadNames?.length + 2 : tableHeadNames?.length > 10 ? 12 : 2}>
                                    <Oval
                                        visible={true}
                                        height="80"
                                        width="80"
                                        secondaryColor={
                                            localStorage.getItem("theme") === "light"
                                                ? "#4E5255"
                                                : "#CFDAE6"
                                        }
                                        color={
                                            localStorage.getItem("theme") === "light"
                                                ? "#2363F7"
                                                : "#4fa94d"
                                        }
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{ height: '50vh', alignItems: 'center', justifyContent: 'center' }}
                                        wrapperClass=""
                                    />
                                </td>
                            </tr>
                        ) : data?.length > 0 ? data?.map((row, i) => {
                            const {
                                id,
                                away_team,
                                home_team,
                                date,
                            } = row;
                            const roundName = getRoundName(row);
                            const prevRoundName = i > 0 ? getRoundName(data[i - 1]) : null;
                            const showRoundHeader = roundName && roundName !== prevRoundName;
                            const isShouldColor = i % 2 === 0;
                            return (
                                <React.Fragment key={id}>
                                    {showRoundHeader && (
                                        <tr className="round-subheader" style={{ backgroundColor: 'transparent' }}>
                                            <td
                                                colSpan={colSpanCount}
                                                style={{
                                                    // padding: '8px 20px',
                                                    // textAlign: 'left',
                                                    // color: '#fff',
                                                    // fontSize: '13px',
                                                    // fontWeight: 500,
                                                    padding: '8px 20px',
                                                    textAlign: 'left',
                                                    color: '#bfe82d',
                                                    fontSize: '13px',
                                                    fontWeight: 500,
                                                    backgroundColor: 'transparent'
                                                }}
                                            >
                                                {roundName}
                                            </td>
                                        </tr>
                                    )}
                                <tr className={isShouldColor ? 'tr-colored' : ''}>
                                    <td className='sticky name'>
                                        <TeamMatches style={{background: 'none'}}>
                                            <TeamName>
                                                <Score>
                                                    <h3 style={{textAlign: 'left'}}>
                                                        <Moment format="DD.MM.YYYY">{date}</Moment>
                                                    </h3>
                                                    <h4
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => window.open(`/tournaments/team/${home_team?.id}`)}
                                                        title={home_team?.name}
                                                    >
                                                        {home_team?.name}
                                                    </h4>
                                                    <h4
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => window.open(`/tournaments/team/${away_team?.id}`)}
                                                        title={away_team?.name}
                                                    >
                                                        {away_team?.name}
                                                    </h4>
                                                </Score>
                                            </TeamName>
                                        </TeamMatches>
                                    </td>
                                    <td className='sticky season'>
                                        <CompetitionMatchItemMenu item={row} tableRef={tableRef} />
                                    </td>
                                    {home_team?.stats?.length > 0 ? home_team?.stats?.map((param, idx) => {
                                        if (!tempSelectedFilters?.checkedIds?.includes(param.parameter_id)) return null;
                                        const isCanClickParam = isCanClickStat(param);
                                        const isCanCliskAwayParam = isCanClickStat(away_team?.stats?.[idx])
                                        const awayParam = away_team?.stats?.[idx];
                                        return (
                                            <td
                                                className='values'
                                                key={`${param.parameter_id}-${idx}`}
                                            >
                                                <span
                                                    style={
                                                        isCanClickParam
                                                            ? { cursor: "not-allowed" }
                                                            : { cursor: "pointer" }
                                                    }
                                                    onClick={() =>
                                                        !isCanClickParam &&
                                                        openVideoList(param.markers?.join(","), `${getParameterDisplayName(param.parameter_name)} - ${home_team?.name}`)
                                                    }
                                                    onContextMenu={(e) => {
                                                        e.preventDefault()
                                                        !isCanClickParam &&
                                                        openVideoList(param.markers?.join(","), `${getParameterDisplayName(param.parameter_name)} - ${home_team?.name}`)
                                                    }
                                                    }
                                                >
                                                    {
                                                        Number.isInteger(param.value)
                                                            ? param?.value?.toLocaleString()
                                                            : param?.value?.toFixed(1)
                                                    }
                                                </span>
                                                <br />{" "}
                                                <span
                                                    style={
                                                        isCanCliskAwayParam
                                                            ? { cursor: "not-allowed" }
                                                            : { cursor: "pointer" }
                                                    }
                                                    onClick={() =>
                                                        !isCanCliskAwayParam &&
                                                        openVideoList(awayParam?.markers?.join(","), `${getParameterDisplayName(awayParam?.parameter_name)} - ${away_team?.name}`)
                                                    }
                                                    onContextMenu={(e) => {
                                                        e.preventDefault()
                                                        !isCanCliskAwayParam &&
                                                        openVideoList(awayParam?.markers?.join(","), `${getParameterDisplayName(awayParam?.parameter_name)} - ${away_team?.name}`)
                                                    }
                                                    }
                                                >
                                                    {
                                                        Number.isInteger(awayParam?.value)
                                                            ? awayParam?.value?.toLocaleString()
                                                            : awayParam?.value?.toFixed(1)
                                                    }
                                                </span>
                                            </td>
                                        )
                                    }) : <td colSpan={tableHeadNames?.length}></td>}
                                </tr>
                                </React.Fragment>
                            )
                        }) : (
                            <tr>
                                <td colSpan={2}>
                                    <EmptyState style={{ height: '50vh', padding: 0 }}>
                                        <img src={emptySearch} alt={emptySearch} />
                                        <h3>{l(314)}</h3>
                                    </EmptyState>
                                </td>
                            </tr>
                        )
                        }
                    </tbody>
                </Table>
            </TopOnlyTableContainer>
        </>
    )
}
